import { getToken, clearToken } from "@/services/auth";
import api from "@/services/api";
import { useMainStore } from "@/store";

const redirectToLogin = () => {
    clearToken();
    location.replace('/login');
};

const revalidateSession = async () => {
    const token = getToken();
    if (!token) return false;

    try {
        const res = await api.post(`/checkToken/${token}`);
        if (res?.data?.valid === true) {
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            useMainStore().$patch({ user: res.data.user });
            return true;
        }
        return false;
    } catch (_) {
        return false;
    }
};

const setup = () => {
    // Check if the token exists and set the Authorization header
    const token = getToken();
    if (token) {
        // Fetch user data and store it in Pinia
        api.post(`/checkToken/${token}`).then((res) => {
            if (res.data.valid === true) {
                console.log('Token is valid');
                api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                console.log(res);
                useMainStore().$patch({
                    user: res.data.user,
                });
            } else {
                console.log('Token is invalid or expired');
                clearToken();
                // Will be handled by response interceptor
            }
        }).catch(err => {
            console.error('Error fetching user data:', err);
            clearToken();
        });
    }

    // Request Interceptor: Set the correct headers (e.g., content-type)
    api.interceptors.request.use(
        (config) => {
            // Automatically set content-type if dealing with FormData
            if (config.data instanceof FormData) {
                config.headers['Content-Type'] = 'multipart/form-data';
            } else {
                config.headers["Content-Type"] = "application/json";
            }

            // Ensure token is in headers if it exists
            const authToken = getToken();
            if (authToken) {
                config.headers["Authorization"] = `Bearer ${authToken}`;
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Response Interceptor: Handle errors like token expiration (e.g., 401 errors)
    api.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalConfig = error.config;

            // Handle 401 Unauthorized (token expiration or invalidation)
            if (error.response && error.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                try {
                    const restored = await revalidateSession();
                    if (restored) {
                        return api(originalConfig);
                    }
                    redirectToLogin();
                } catch (_error) {
                    console.error('Token validation failed:', _error);
                    redirectToLogin();
                    return Promise.reject(_error);
                }
            }

            return Promise.reject(error);
        }
    );
};

export default setup;
